module.exports = __webpack_public_path__ + "static/img/luckyDraw_title.6ad10b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/luckyDraw_title.png
// module id = zCOk
// module chunks = 1